/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Expense_ReportsInputs */

const vi_nav_expense_reports = /** @type {(inputs: Nav_Expense_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo chi phí`)
};

/**

* @param {Nav_Expense_ReportsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_expense_reports = /** @type {((inputs?: Nav_Expense_ReportsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Expense_ReportsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_expense_reports(inputs)
});